export default {
  'de-AT': require(`./de-AT.json`),
  'de-CH': require(`./de-CH.json`),
  'de-DE': require(`./de-DE.json`),
  'en-US': require(`./en-US.json`),
  'fr-FR': require(`./fr-FR.json`),
};
